import BlankCouponHistory from '@components/blank/BlankCouponHistory';
import Column from '@components/Column';
import InfinityScrollTrigger from '@components/InfinityScrollTrigger';
import Loading from '@components/Loading';
import styled from '@emotion/styled';

import useCouponHistories from './hooks/useCouponHistories';
import CouponFilter from '../../components/CouponFilter';
import CouponItem from '../../components/CouponItem';

function CouponHistoryFragment() {
    const {
        sort, setSort, coupons, isEmpty, fetchNextPage, isFetching,
    } = useCouponHistories();
    return (
        <Column fullWidth>
            <CouponFilter sort={sort} setSort={setSort}/>
            <Container fullWidth as='section'
                align='center'
                spacing={16}>
                {coupons?.map((coupon) => (
                    <CouponItem coupon={coupon} isHistory key={ coupon.couponId} />
                ))}
            </Container>
            <InfinityScrollTrigger trigger={fetchNextPage} />
            {isEmpty && (<BlankCouponHistory/>)}
            {isFetching && (<Loading size='small' />)}
        </Column>
    );
}

const Container = styled(Column)`
    padding: 0 20px;
`;

export default CouponHistoryFragment;
